import { useQuery } from 'react-query';
import { getSceneAllParagraphs } from '../../services/sceneService';

export function useGetSceneAllParagraphs(sceneId: string, options?: { enabled?: boolean }) {
  const enabled = options?.enabled ?? true;

  return useQuery(['sceneAllParagraphs', sceneId], () => getSceneAllParagraphs(sceneId), {
    enabled: !!sceneId && enabled,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    staleTime: 60 * 1000,
    cacheTime: 5 * 60 * 1000
  });
}
